import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

/**
 *
 *
 *
 * @returns { users, loading, error, changePassword };
 */
export default function useUsers() {
  const [users, setUsers] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  const changePassword = async (id, newPassword) => {
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/merchant-users/${id}/password`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(
                localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_NAME)
              ).access_token,
          },
          body: JSON.stringify({
            password: newPassword,
          }),
        }
      );
      if (result.ok) {
        return ["Success", null];
      } else {
        const errorResult = await result.json();
        return [null, errorResult];
      }
    } catch (err) {
      return [null, { message: "Some thing went wrong" }];
    }
  };

  useEffect(() => {
    async function fetchAll() {
      try {
        const users = await dataProvider.getList("merchant-users", {});

        setUsers(users.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { users, loading, error, changePassword };
}
